import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetReleaseNotes = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<string>(
    'release-notes',
    async () => {
      try {
        const res = await fetch(`${APIBaseChronos}/api/release-notes`, fetchConfigGET);
        return await res.text();
      } catch (err) {
        return '';
      }
    },
    {},
  );
};
